// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationInformation_wrapper__TADzC","image":"OrganizationInformation_image__JzYrF"};